(() => {
  if (window.ValeeraAttribution) return;
  const key = 'valeera_lander_attribution_v1';
  const ttl = 30 * 60 * 1000;
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'ad_id', 'adset_id', 'campaign_id', 'placement', 'site_source', 'creative_batch'];
  const config = JSON.parse(document.getElementById('pet-analytics-config')?.textContent || '{}');
  const internal = config.design || config.role !== 'main' || /[?&](preview_theme_id|pet_analytics_debug|pet_debug)=/.test(location.search);
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true && navigator.globalPrivacyControl !== true;
  const token = value => typeof value === 'string' && /^[a-zA-Z0-9_.: -]{1,80}$/.test(value) ? value : '';
  let context = null;
  let cartSignature = '';
  let cartPending = false;
  let clarityTimer;
  let clarityAttempts = 0;
  const decorated = new Map();
  const creativeParts = content => {
    const staticMatch = content?.match(/^(statics\d{8})_(static(?:2[abc]|3a[12]|3[bc]|7|10|n[123]))_(l1|pdp)_valeera$/);
    if (staticMatch) return { copy: staticMatch[2], angle: '', image: staticMatch[2], page: 'valeera', destination: staticMatch[3], batch: staticMatch[1] };
    const match = content?.match(/^copy(\d{2})(?:_(a0[1-6]))?_img([1-9]|10)(?:_(l[12]|pdp))?(?:_(lucy|valeera))?$/);
    return match ? { copy: 'copy' + match[1], angle: match[2] || '', image: 'img' + match[3], page: match[5] || '', destination: match[4] || '', batch: '' } : { copy: '', angle: '', image: '', page: '', destination: '', batch: '' };
  };
  const parse = () => {
    let stored;
    try { stored = JSON.parse(sessionStorage.getItem(key)); } catch {}
    const now = Date.now();
    const previous = stored && now >= stored.at && now - stored.at < ttl ? stored : null;
    const url = new URL(location.href);
    const lander = url.pathname.match(/^\/pages\/(l[12])\/?$/)?.[1];
    const incoming = {};
    for (const name of fields) {
      const value = token(url.searchParams.get(name));
      if (value) incoming[name] = value;
    }
    if (lander) {
      const params = Object.keys(incoming).length ? incoming : (previous?.lander === lander ? previous.params : {});
      const parts = creativeParts(params.utm_content);
      return { at: now, lander, ...parts, params };
    }
    const isPdp = /^(?:\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?|\/products\/[^/]+\/?)$/.test(url.pathname);
    const directPdp = creativeParts(incoming.utm_content);
    if (isPdp && url.searchParams.get('lander') === 'pdp' && directPdp.destination === 'pdp') {
      return { at: now, lander: 'pdp', ...directPdp, params: incoming };
    }
    if (Object.keys(incoming).length && (!previous || Object.entries(incoming).some(([name, value]) => previous.params[name] !== value))) return null;
    return previous ? { ...previous, at: now } : null;
  };
  const carryLinks = () => {
    if (!context || !permitted()) return;
    for (const link of document.querySelectorAll('a[href]')) {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#')) continue;
      let url;
      try { url = new URL(raw, location.href); } catch { continue; }
      if (url.origin !== location.origin || !/^(?:\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?|\/products\/[^/]+\/?|\/cart\/?)$/.test(url.pathname)) continue;
      if (!decorated.has(link)) decorated.set(link, raw);
      for (const [name, value] of Object.entries(context.params)) if (!url.searchParams.has(name)) url.searchParams.set(name, value);
      url.searchParams.set('lander', context.lander);
      link.href = url.href;
    }
  };
  const tagClarity = () => {
    if (!context || !permitted() || internal) return;
    if (typeof window.clarity !== 'function') {
      if (++clarityAttempts < 30) clarityTimer = setTimeout(tagClarity, 1000);
      return;
    }
    const tags = { lander_variant: context.lander, ad_copy: context.copy, ad_angle: context.angle, ad_page: context.page, ad_image: context.image, ad_batch: context.batch || 'unclassified', ad_content: context.params.utm_content, meta_ad_id: context.params.ad_id, meta_adset_id: context.params.adset_id };
    for (const [name, value] of Object.entries(tags)) if (value) window.clarity('set', name, value);
  };
  const cartFields = ['lander', 'copy', 'angle', 'page', 'image', ...fields];
  const syncCart = async () => {
    if (!context || !permitted() || internal || cartPending || /^\/pages\//.test(location.pathname)) return;
    const values = { lander: context.lander, copy: context.copy, angle: context.angle, page: context.page, image: context.image, ...context.params, creative_batch: context.batch || '' };
    const attributes = Object.fromEntries(cartFields.map(name => ['__valeera_' + name, values[name] || '']));
    const body = JSON.stringify({ attributes });
    if (cartSignature === body) return;
    cartPending = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body, keepalive: true,
      });
      if (response.ok && permitted()) cartSignature = body;
    } catch {} finally { cartPending = false; }
  };
  const refresh = () => {
    clearTimeout(clarityTimer);
    if (!permitted()) {
      context = null;
      try { sessionStorage.removeItem(key); } catch {}
      for (const [link, original] of decorated) link.setAttribute('href', original);
      decorated.clear();
      return;
    }
    context = parse();
    if (!context) { try { sessionStorage.removeItem(key); } catch {} return; }
    if (!internal) { try { sessionStorage.setItem(key, JSON.stringify(context)); } catch {} }
    carryLinks();
    clarityAttempts = 0;
    tagClarity();
    void syncCart();
  };
  window.ValeeraAttribution = { version: 'lander-v5-20261019-statics', getContext: () => context ? structuredClone(context) : null };
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('cart:update', () => { void syncCart(); carryLinks(); });
  document.addEventListener('click', () => { if (context && permitted()) void syncCart(); }, { capture: true, passive: true });
  if (window.Shopify?.customerPrivacy) refresh();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) refresh(); });
})();

